import { c as _c } from "react/compiler-runtime";
import { DangerButton, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { ContactSubscriptionsInterface } from 'modules/contacts/contact-page/types/contact-subscriptions-interface';
import { SubscriptionInterface } from 'modules/payment/subscriptions/types/subscription-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUnsubscribe } from '../hooks/use-unsubscribe';
import { getPaymentProcessorUnsubscribeOptions } from '../utils/get-payment-processor-unsubscribe-options';
interface UnsubscribeModalProps<Instance extends SubscriptionInterface | ContactSubscriptionsInterface> {
  opened: boolean;
  onClose: () => void;
  subscription: Instance;
  onUnsubscribe: (subscription: Instance) => Promise<void>;
}
function UnsubscribeModal(t0) {
  const $ = _c(65);
  const {
    opened,
    onClose,
    subscription,
    onUnsubscribe
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== subscription.id || $[1] !== subscription.paymentProcessor || $[2] !== subscription.subscriptionItems) {
    t1 = getPaymentProcessorUnsubscribeOptions(subscription.paymentProcessor, subscription.id, subscription.subscriptionItems);
    $[0] = subscription.id;
    $[1] = subscription.paymentProcessor;
    $[2] = subscription.subscriptionItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    requestMethod,
    getRequestUrl,
    getRequestBody
  } = t1;
  let t2;
  if ($[4] !== getRequestBody || $[5] !== getRequestUrl || $[6] !== requestMethod) {
    t2 = {
      requestMethod,
      getRequestUrl,
      getRequestBody
    };
    $[4] = getRequestBody;
    $[5] = getRequestUrl;
    $[6] = requestMethod;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    unsubscribe,
    isFetchingWhenEnds,
    isFetchingNow
  } = useUnsubscribe(t2);
  let t3;
  if ($[8] !== onClose || $[9] !== onUnsubscribe || $[10] !== subscription || $[11] !== t || $[12] !== unsubscribe) {
    t3 = async () => {
      ;
      try {
        await unsubscribe({
          time: "when_ends"
        });
        await onUnsubscribe(subscription);
        onClose();
        toast.success(t("dashboard.subscriptions.unsubscribed_later"));
      } catch (t4) {
        toast.error(t("global.error"));
      }
    };
    $[8] = onClose;
    $[9] = onUnsubscribe;
    $[10] = subscription;
    $[11] = t;
    $[12] = unsubscribe;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const unsubWhenEnds = t3;
  let t4;
  if ($[14] !== onClose || $[15] !== onUnsubscribe || $[16] !== subscription || $[17] !== t || $[18] !== unsubscribe) {
    t4 = async () => {
      ;
      try {
        await unsubscribe({
          time: "now"
        });
        await onUnsubscribe(subscription);
        onClose();
        toast.success(t("dashboard.subscriptions.unsubscribed"));
      } catch (t5) {
        toast.error(t("global.error"));
      }
    };
    $[14] = onClose;
    $[15] = onUnsubscribe;
    $[16] = subscription;
    $[17] = t;
    $[18] = unsubscribe;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const unsubNow = t4;
  let t5;
  if ($[20] !== onClose) {
    t5 = () => {
      onClose();
    };
    $[20] = onClose;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setError("");
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t) {
    t7 = t("dashboard.subscriptions.unsubscribe_confirm");
    $[23] = t;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const t8 = isFetchingWhenEnds || isFetchingNow;
  const t9 = subscription.subscriptionItems[0].orderItem.pricePlan?.innerName;
  let t10;
  if ($[25] !== subscription.customer.fullName || $[26] !== t9) {
    t10 = {
      product: t9,
      customer: subscription.customer.fullName
    };
    $[25] = subscription.customer.fullName;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      b: <span className="font-bold" />
    };
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t || $[30] !== t10) {
    t12 = <div className="flex justify-center"><p><span className="text-text-primary text-base"><TransLoco t={t} i18nKey="dashboard.subscriptions.unsubscribe_confirm_text" values={t10} components={t11} /></span></p></div>;
    $[29] = t;
    $[30] = t10;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== unsubNow) {
    t13 = async e_1 => {
      e_1.preventDefault();
      await unsubNow();
    };
    $[32] = unsubNow;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t) {
    t14 = t("dashboard.subscriptions.unsub_now");
    $[34] = t;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== isFetchingNow || $[37] !== isFetchingWhenEnds || $[38] !== t13 || $[39] !== t14) {
    t15 = <DangerButton isFetching={isFetchingNow} width="large" onClick={t13} disabled={isFetchingWhenEnds}>{t14}</DangerButton>;
    $[36] = isFetchingNow;
    $[37] = isFetchingWhenEnds;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== unsubWhenEnds) {
    t16 = async e_2 => {
      e_2.preventDefault();
      await unsubWhenEnds();
    };
    $[41] = unsubWhenEnds;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t) {
    t17 = t("dashboard.subscriptions.unsub_period");
    $[43] = t;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== isFetchingNow || $[46] !== isFetchingWhenEnds || $[47] !== t16 || $[48] !== t17) {
    t18 = <PrimaryButton isFetching={isFetchingWhenEnds} className="w-full text-base" width="large" onClick={t16} disabled={isFetchingNow} type="submit">{t17}</PrimaryButton>;
    $[45] = isFetchingNow;
    $[46] = isFetchingWhenEnds;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t15 || $[51] !== t18) {
    t19 = <div className="flex justify-center gap-4 max-sm:flex-wrap">{t15}{t18}</div>;
    $[50] = t15;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== error) {
    t20 = <FieldErrorAndDescription error={error} errorClassName="text-center" />;
    $[53] = error;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t12 || $[56] !== t19 || $[57] !== t20) {
    t21 = <form className="flex flex-col gap-6 lg:gap-10">{t12}{t19}{t20}</form>;
    $[55] = t12;
    $[56] = t19;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== opened || $[60] !== t21 || $[61] !== t5 || $[62] !== t7 || $[63] !== t8) {
    t22 = <Modal opened={opened} onClose={t5} className="max-w-max" afterLeave={t6} title={t7} isFetching={t8} isCentered={true}>{t21}</Modal>;
    $[59] = opened;
    $[60] = t21;
    $[61] = t5;
    $[62] = t7;
    $[63] = t8;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  return t22;
}
export default UnsubscribeModal;